export default "__VITE_ASSET__CgFmX_VO__"